import get from 'lodash/get';
import actionCreators from 'spark-state/actionCreators';
import { remove } from 'spark-util/objects';
import { CHANGE_ENTERPRISE } from '../user/userReducer';

//Mostly dealing with initialization of the app
export const INITIALIZE_AUTH = 'APP.INITIALIZE_AUTH';
export const AUTH_SUCCESS = 'APP.AUTH_SUCCESS';
export const AUTH_FAILURE = 'APP.AUTH_FAILURE';
export const LOGOUT_USER = 'APP.LOGOUT_USER';
export const CHANGE_ENTERPRISE_USER = 'CHANGE_ENTERPRISE_USER';
export const READY = 'APP.READY';
export const initializeAuth = actionCreators.message(INITIALIZE_AUTH);
export const authSuccess = actionCreators.message(AUTH_SUCCESS);
export const authFailure = actionCreators.message(AUTH_FAILURE);
export const logOut = actionCreators.message(LOGOUT_USER);
export const changeEnterpriseUser = actionCreators.message(CHANGE_ENTERPRISE_USER);
export const appReady = actionCreators.message(READY);

//These are more global level actions, which is why they're currently
//grouped with APP. When we get more of these, maybe we can move them
//into a more specific file
export const RESOURCE_NOT_FOUND = 'APP.RESOURCE_NOT_FOUND';
export const GAP_PACKET_ACCESS_DENIED = 'APP.GAP_PACKET_ACCESS_DENIED';
export const INVESTIGATOR_BROCHURE_ACCESS_DENIED = 'APP.INVESTIGATOR_BROCHURE_ACCESS_DENIED';
export const OPEN_TEMP_ROUTE = 'APP.OPEN_TEMP_ROUTE';
export const CLOSE_TEMP_ROUTE = 'APP.CLOSE_TEMP_ROUTE';
export const SET_KC_TOKEN = 'APP.SET_KC_TOKEN';
export const SET_MAPPED_ENTERPRISE_DATA = 'SET_MAPPED_ENTERPRISE_DATA';
export const LOADER = 'LOADER';
export const SAVEBUTTONDISABLEENABLE = 'SAVEBUTTONDISABLEENABLE'

export const resourceNotFound = actionCreators.message(RESOURCE_NOT_FOUND);
export const gapPacketAccessDeniedAction = actionCreators.message(GAP_PACKET_ACCESS_DENIED);
export const investigatorBrochureAccessDeniedAction = actionCreators.message(INVESTIGATOR_BROCHURE_ACCESS_DENIED);
export const openTempRoute = (name, params) => ({
    type: OPEN_TEMP_ROUTE,
    name,
    params
});
export const closeTempRoute = name => ({
    type: CLOSE_TEMP_ROUTE,
    name
});
export const kcToken = kcToken => ({
    type: SET_KC_TOKEN,
    kcToken
});
export const setMappedEnterpriseData = mappedEnterpriseData => {
    return {
        type: SET_MAPPED_ENTERPRISE_DATA,
        mappedEnterpriseData
    };
};

export const loader = loader => {
    return {
        type: LOADER,
        loader
    };
};

export const saveButton = saveButton => {
    return {
        type: SAVEBUTTONDISABLEENABLE,
        saveButton
    }
}

export const isAuthenticating = state => state.app.authenticating;
export const isLoggedIn = state => state.app.loggedIn;
export const isLoggedOut = state => state.app.loggedOut;
export const isReady = state => state.app.isReady;
export const kcCurrentToken = state => state.app.kcToken;
export const getMappedEnterpriseData = state => get(state, 'app.mappedEnterpriseData');
export const hasLoaded = state => state.app.loader;
export const saveButtoneEnableDisable = state => state.app.saveButton;

export const isTempRouteOpen = (state, name) => !!state.app.tempRoutes[name];
export const getTempRouteParams = (state, name) => get(state, `app.tempRoutes.${name}`);

const initialState = {
    authenticating: false,
    loggedIn: false,
    loggedOut: false,
    isReady: false,
    tempRoutes: {},
    kcToken: null,
    mappedEnterpriseData: [],
    loader: false,
    saveButton: true
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case INITIALIZE_AUTH: {
            return { ...initialState, authenticating: true };
        }
        case AUTH_SUCCESS: {
            return {
                ...state,
                authenticating: false,
                loggedIn: true
            };
        }
        case AUTH_FAILURE: {
            return {
                ...state,
                authenticating: false,
                loggedIn: false
            };
        }
        case LOGOUT_USER: {
            return { ...initialState, loggedOut: true };
        }
        case READY: {
            return {
                ...state,
                isReady: true
            };
        }
        case CHANGE_ENTERPRISE: {
            return {
                ...initialState,
                isReady: true,
                loggedIn: true
            };
        }
        case OPEN_TEMP_ROUTE: {
            return {
                ...state,
                tempRoutes: {
                    ...state.tempRoutes,
                    [action.name]: action.params || {}
                }
            };
        }
        case CLOSE_TEMP_ROUTE: {
            return {
                ...state,
                tempRoutes: remove(action.name, state.tempRoutes)
            };
        }
        case SET_KC_TOKEN: {
            return {
                ...state,
                kcToken: action.kcToken
            };
        }
        case SET_MAPPED_ENTERPRISE_DATA: {
            // SAF-20237: Role Assignment - Switch Roles and its Precedence - PSR-4763
            // Transform new API structure (rolesByModule) to flat roles array for backward compatibility
            const rawData = get(action, 'mappedEnterpriseData.data', []);
            const transformedData = rawData.map(enterprise => {
                if (enterprise.rolesByModule) {
                    // Transform rolesByModule object to flat roles array
                    // Each module (SAFETY, GP, IB) has at most one role per enterprise
                    const modulePriority = ['SAFETY', 'GP', 'IB'];
                    const flatRoles = [];
                    
                    modulePriority.forEach(module => {
                        const moduleRoles = enterprise.rolesByModule[module];
                        if (moduleRoles && Array.isArray(moduleRoles) && moduleRoles.length > 0) {
                            // Take the first (and only) role for this module
                            flatRoles.push({
                                ...moduleRoles[0],
                                category: module  // Add category field for email deep link routing
                            });
                        }
                    });
                    
                    return {
                        ...enterprise,
                        roles: flatRoles,
                        rolesByModule: undefined // Remove transformed data to keep state clean
                    };
                }
                return enterprise;
            });
            
            return {
                ...state,
                mappedEnterpriseData: transformedData
            };
        }
        case LOADER: {
            return {
                ...state,
                loader: action.loader
            };
        }
        case SAVEBUTTONDISABLEENABLE: {
            return {
                ...state,
                saveButton: action.saveButton
            }
        }
        default: {
            return state;
        }
    }
};
